module.exports = __webpack_public_path__ + "static/img/vip-hour-chest.815c3fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-welfare/vip-hour-chest.png
// module id = x/pu
// module chunks = 216